// The backend names each step a load step (kind 'S': S1, S2, ...) or an unload
// step ('U': U1, U2, ...). A payload from before that has neither, and its
// steps are all treated as load steps.
export function stepLabel(step) {
  if (!step) return '';
  return step.label || `S${step.step}`;
}

export function isUnloadStep(step) {
  return step?.kind === 'U';
}

// The dashboard shows the load steps; showUnload adds the unload steps.
export function shownSteps(steps, showUnload) {
  const list = Array.isArray(steps) ? steps : [];
  return showUnload ? list : list.filter((s) => !isUnloadStep(s));
}

const SHOW_UNLOAD_KEY = 'lt-show-unload-steps';

export function readShowUnload() {
  try {
    return localStorage.getItem(SHOW_UNLOAD_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeShowUnload(show) {
  try {
    localStorage.setItem(SHOW_UNLOAD_KEY, show ? '1' : '0');
  } catch {
    // ignore
  }
}

// A test box paired with its logger on site by tracker proximity, logger
// online, no test recorded yet (the API's about_to_start).
export const ABOUT_TO_START = { color: '#a855f7', label: 'Test about to start' };

// Where the test stands (test_status in the payload). description is the
// hover text on the status chip.
export const TEST_STATUS = {
  in_progress: {
    label: 'In progress', color: 'info',
    description: 'The pile is loaded and the logger is still sending readings.',
  },
  unloading: {
    label: 'Unloading', color: 'warning',
    description: 'The latest step is an unload step and the logger is still sending readings.',
  },
  unloaded: {
    label: 'Back at zero', color: 'warning',
    description: 'The load is back at zero. The test is confirmed complete after an hour at zero; a reload within that hour continues the same test.',
  },
  complete: {
    label: 'Complete', color: 'success',
    description: 'The load came back to zero and stayed there for an hour, or the readings stopped while it was at zero.',
  },
  // The readings stopped while the pile was still loaded (stored as 'incomplete').
  incomplete: {
    label: 'Ended under load', color: 'warning',
    description: 'The readings stopped while the pile was still loaded: the logger went offline, there was a gap of more than 8 hours, or the job, point or test number changed mid-test.',
  },
  no_valid_readings: {
    label: 'Missing Sensors', color: 'error',
    description: 'This recording has no load cell readings.',
  },
};
